<template>
  <div class="container">
    <h1>{{ $t('title') }}</h1>
    <h2>{{ $t('subtitle') }}</h2>
    <i18n path="info" tag="p">
      <a
        href="mailto:service@gs1-germany.de?subject=API%20Verified%20by%20GS1"
        >{{ $t('use_apis') }}</a
      >
    </i18n>
    <div v-if="limit" class="alert alert-danger" role="alert">
      {{ $t('limitText') }}
    </div>
    <form class="form" @submit.prevent="submit">
      <h3>
        {{ $t('barcode_numbers') }}
        <span v-if="!empty" class="small"
          >({{ lines.length + ' ' + $tc('entered', lines.length) }})</span
        >
      </h3>
      <div class="form-group">
        <textarea
          v-model="text"
          maxlength="16000"
          class="form-control"
          rows="10"
          :placeholder="$t('placeholder')"
        ></textarea>
      </div>
      <p class="or">{{ $t('or') }}</p>
      <h3>
        {{ $t('file_upload') }}
        <span class="small">(*.csv, *.txt, *.xlsx)</span>
      </h3>
      <div class="form-group">
        <input type="file" @change="fileChanged" accept=".csv,.txt,.xlsx" />
        <span v-if="error" class="help-block error"
          >{{ $t('error') }}: {{ $t(error) }}</span
        >
      </div>
      <button type="submit" class="btn btn-primary" :disabled="empty || limit">
        {{ $t('button') }}
      </button>
    </form>
  </div>
</template>

<script>
/* eslint-disable */
import readXlsxFile from 'read-excel-file'

export default {
  data() {
    return {
      file: null,
      text: '',
      error: null,
      plainFileTypes: ['text/plain', 'text/csv'],
      xslxFileTypes: [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-excel'
      ]
    }
  },
  computed: {
    lines() {
      return this.text
        .split(/[\n\r.;,\s]/)
        .filter(line => line && /^\d+$/.test(line))
        .map(l => l.replace(/\s/g, ''))
    },
    empty() {
      return this.lines.length === 0 && !this.file
    },
    limit() {
      return this.lines.length > 500
    }
  },
  methods: {
    fileChanged(event) {
      if (event.target.files && event.target.files[0]) {
        this.file = event.target.files[0]
        // xslx file
        if (this.xslxFileTypes.includes(this.file.type))
          readXlsxFile(this.file).then(rows => {
            this.text = rows
              .flat(1)
              .map(l => (typeof l === 'string' ? l.replace(/\s/g, '') : '' + l))
              .filter(line => line && /^\d+$/.test(line))
              .join('\n')
          })
        // plain file
        else if (this.plainFileTypes.includes(this.file.type)) {
          new Response(this.file).text().then(
            text => {
              this.text = text
                .split(/[\n\r.;,\s]/)
                .map(l => l.replace(/\s/g, ''))
                .filter(line => line && /^\d+$/.test(line))
                .join('\n')
            },
            error => {
              console.log(error)
            }
          )
        }
        // no file type match
        else this.error = 'error_unsupported_media_type'
      }
    },
    submit() {
      this.$router.push({ name: 'Results', query: { g: this.lines } })
    }
  },
  i18n: {
    messages: {
      de: {
        title: 'Verified by GS1',
        subtitle: 'Mehrfachabfrage',
        info: 'Bis zu 500 Idente gleichzeitig überprüfen. Sie können die Idente als Text einfügen oder eine Datei hochladen.',
        use_apis: 'GS1 Service Team',
        barcode_numbers: 'Ident Suche',
        or: 'oder',
        file_upload: 'Datei-Upload',
        entered: 'eingegeben',
        placeholder: 'Bis zu 500 Idente eingeben (ein Ident pro Zeile)',
        button: 'Suchen',
        error: 'Fehler',
        error_unknown: 'Ein unbekannter Fehler ist aufgetreten.',
        error_unsupported_media_type:
          'Dieses Dateiformat wird nicht unterstützt.',
        limitText: 'Achtung! Das Limit pro Suche beträgt 500 Idente.'
      },
      en: {
        title: 'Verified by GS1',
        subtitle: 'Bulk search',
        info: 'Search for up to 500 Idents by copy/pasting the data or uploading a file below.',
        use_apis: 'GS1 Service Team',
        barcode_numbers: 'Idents',
        or: 'or',
        file_upload: 'File upload',
        entered: 'entered',
        placeholder: 'Enter up to 500 Idents (one per line)',
        button: 'Search',
        error: 'Error',
        error_unknown: 'An unknown error occurred.',
        error_unsupported_media_type: 'The file format is not supported.',
        limitText: 'Attention! The limit per search is 500 Idents.'
      }
    }
  }
}
</script>

<style scoped>
.toolkit h1 {
  margin-bottom: 8px;
}

.toolkit h2 {
  margin: 0 0 8px 0;
}

.toolkit h3 {
  margin: 0 0 30px 0;
}

.toolkit p {
  color: var(--gs1-dark-gray);
  font-size: 20px;
  font-weight: 300;
  line-height: 1.5;
  margin: 0 0 50px 0;
}

.toolkit p.or {
  font-style: italic;
}

.toolkit p a {
  font-weight: 300;
}

.toolkit form .form-group {
  margin-bottom: 50px;
}

.toolkit form textarea.form-control {
  resize: none;
}

.toolkit form .btn-primary {
  padding: 0 52px;
}

.toolkit form span.small {
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/router/views/Bulk.vue